var $ = window.jQuery;

var DELETE_PROMPT = 'Are you sure you want to delete this internal note? This action cannot be undone.';

function handleInFormDelete(e) {
  e.preventDefault();
  var $btn = $(this);
  var noteId = $btn.data('note-id');
  var nonce = $btn.data('nonce');
  var $timeline = $btn.closest('.operator-internal-notes-timeline');
  var enquiryId = $timeline.data('enquiry-id');
  if (!noteId || !nonce || !enquiryId) {
    return;
  }
  if (!window.confirm(DELETE_PROMPT)) {
    return;
  }
  $btn.prop('disabled', true);
  var $item = $btn.closest('.operator-internal-notes-timeline__item');
  var ajaxUrl = (window.tofinoJS && window.tofinoJS.ajaxUrl) || window.ajaxurl || '/wp/wp-admin/admin-ajax.php';
  $.post(ajaxUrl, {
    action: 'delete_operator_internal_note',
    note_id: noteId,
    enquiry_id: enquiryId,
    hub_action_nonce: nonce
  }).done(function (res) {
    if (res && res.success) {
      $item.slideUp(200, function () {
        $(this).remove();
      });
    } else {
      window.alert((res && res.data && res.data.msg) ? res.data.msg : 'Could not delete note.');
      $btn.prop('disabled', false);
    }
  }).fail(function () {
    window.alert('Network error. Could not delete note.');
    $btn.prop('disabled', false);
  });
}

function handleModalDelete(e) {
  e.preventDefault();
  var $btn = $(this);
  var noteId = $btn.data('note-id');
  var nonce = $btn.data('nonce');
  var $modal = $btn.closest('.operator-internal-notes-modal');
  var enquiryId = $modal.data('enquiry-id');
  if (!noteId || !nonce || !enquiryId) {
    return;
  }
  if (!window.confirm(DELETE_PROMPT)) {
    return;
  }
  $btn.prop('disabled', true);
  var ajaxUrl = (window.tofinoJS && window.tofinoJS.ajaxUrl) || window.ajaxurl || '/wp/wp-admin/admin-ajax.php';
  $.post(ajaxUrl, {
    action: 'delete_operator_internal_note',
    note_id: noteId,
    enquiry_id: enquiryId,
    hub_action_nonce: nonce
  }).done(function (res) {
    if (res && res.success) {
      $btn.closest('.operator-internal-notes-modal__item').slideUp(200, function () {
        $(this).remove();
      });
    } else {
      window.alert((res && res.data && res.data.msg) ? res.data.msg : 'Could not delete note.');
      $btn.prop('disabled', false);
    }
  }).fail(function () {
    window.alert('Network error. Could not delete note.');
    $btn.prop('disabled', false);
  });
}

export default function () {
  $(document)
    .off('click.operatorInternalNotes')
    .on('click.operatorInternalNotes', '.operator-internal-notes-timeline__delete', handleInFormDelete)
    .on('click.operatorInternalNotes', '.operator-internal-notes-modal__delete', handleModalDelete);
}
